import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBox from '../../../layout/component/ContentBox'
import { formatDate } from '../../../../util/datetime'
import { INVOICE_TYPE_INVOICE, INVOICE_TYPE_INVOICE_CORRECTION } from '../../../../constant/invoice-constant'
import { formatMoney } from '../../../../util/money'
import ConfirmationModal from '../../../form/component/ConfirmationModal'
import { BACKEND_URL } from '../../../../util/api'
import currentUserHasAccess from '../../../../util/widget-helper'
import { INVOICE_LIST_WIDGET } from '../../../process/ui-definition/process-ui'


const PRODUCT_TYPE = {
    set: 'Set',
    treatment: 'Treatment',
    retainer: 'Retainer',
    'retainer-new' : 'Retainer New',
    'implant-treatment': 'Implant Treatment',
    'retainer-refinement': 'Retainer Refinement',
    'retainer-refinement-new': 'Retainer Refinement New'
}

const INVOICE_TYPE_LIST = {
    [INVOICE_TYPE_INVOICE_CORRECTION]: 'Correction',
    [INVOICE_TYPE_INVOICE]: 'Invoice',
}


const Invoice = ({ invoice, createCorrection, onCorrectionCreated, showConfirmationModal }) => {
    const productType = invoice.thirdParty ? 'Physician' : PRODUCT_TYPE[invoice.type]
    const invoiceType = INVOICE_TYPE_LIST[invoice.invoiceType]

    const downloadLink = BACKEND_URL + '/api/invoice/pdf/download?fileId=' + invoice.fileId
    const viewLink = BACKEND_URL + '/api/invoice/pdf/view?fileId=' + invoice.fileId

    const showCorrection = invoice.invoiceType === INVOICE_TYPE_INVOICE && !invoice.thirdParty

    return (
        <tr>
            <td>{productType}</td>
            <td>{invoice.referenceNumber}</td>
            <td>{formatDate(invoice.created)}</td>
            <td>{invoiceType}</td>
            <td><a href={downloadLink}>download</a></td>
            <td><a href={viewLink} target="_blank" rel="noopener noreferrer">view</a></td>
            <td>{formatMoney(invoice.brutPrice, invoice.currency)}</td>
            {onCorrectionCreated && (<td>
                {showCorrection && <button
                    onClick={() => {
                        showConfirmationModal(invoice)
                    }}
                    className="btn btn-primary btn-sm">correction
                </button>}
            </td>)}
        </tr>
    )
}


const InvoiceList = ({ invoice, invoiceList, onCorrectionCreated, createCorrection, confirmationModalOpen, showConfirmationModal, closeConfirmationModal }) => {
    if (!currentUserHasAccess(INVOICE_LIST_WIDGET)) {
        return null
    }

    let total = 0

    const currency = (invoiceList && invoiceList.length) ? invoiceList[0].currency : 'EUR'
    return (
        <ContentBox title="Invoices ">
            <ConfirmationModal showModal={confirmationModalOpen} confirmClicked={() => {
                createCorrection(onCorrectionCreated)
            }} cancelClicked={closeConfirmationModal}>Please confirm the creation of invoice correction for invoice {invoice && <span>{invoice.referenceNumber}</span>}</ConfirmationModal>

            <Row>
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>Reference Number</th>
                                <th>Created</th>
                                <th>Type</th>
                                <th>Download</th>
                                <th>View</th>
                                <th>Brut</th>
                                {onCorrectionCreated && (<th>Correction</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceList.map(invoice => {
                                if (!invoice.thirdParty) {
                                    total += invoice.brutPrice
                                }

                                return <Invoice
                                    key={invoice.id}
                                    invoice={invoice}
                                    showConfirmationModal={showConfirmationModal}
                                    closeConfirmationModal={closeConfirmationModal}
                                    onCorrectionCreated={onCorrectionCreated}
                                    createCorrection={createCorrection}/>
                            })}
                            <tr>
                                <td colSpan="6"><b>Total (Sunshine Smile)</b></td>
                                <td><b>{formatMoney(total, currency)}</b></td>
                                {onCorrectionCreated && (<td/>)}
                            </tr>
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}

InvoiceList.propTypes = {
    invoiceList: PropTypes.array.isRequired,
    createCorrection: PropTypes.func,
    onCorrectionCreated: PropTypes.func,
}

export default InvoiceList




// WEBPACK FOOTER //
// ./src/modules/invoice/component/list/InvoiceList.js